import {
  CardCvcField,
  CardExpiryMonthField,
  CardExpiryYearField,
  CardNameField,
  CardNumberField
} from '@anm/components/form/fields';
import { STRIPE_LIB_URL } from '@anm/constants/services';
import { injectGlobal } from '@anm/helpers/stateful/injectGlobal';
import { FC } from 'react';

import {
  CardCvcFieldWrapper,
  CardFrontView,
  CardFrontViewExpiresBlock,
  CardFrontViewNameBlock,
  CardFrontViewRow,
  CardIcons,
  CardNumberFieldWrapper,
  EditCardView,
  Slash
} from './Wrapper';

export type EditCardProps = {
  className?: string;
};

injectGlobal({
  head: <script src={STRIPE_LIB_URL} />
});

const EditCard: FC<EditCardProps> = ({ className }) => (
  <EditCardView className={className}>
    <CardFrontView>
      <CardIcons />
      <CardNumberFieldWrapper>
        <CardNumberField
          autoFocus={true}
          labelVariant="static-above-dark-uppercase"
          inputVariant="simple-small"
        />
      </CardNumberFieldWrapper>
      <CardFrontViewRow>
        <CardFrontViewNameBlock>
          <CardNameField
            labelVariant="static-above-dark-uppercase"
            inputVariant="simple-small"
          />
        </CardFrontViewNameBlock>

        <CardFrontViewExpiresBlock>
          <CardExpiryMonthField
            inputVariant="short"
            labelVariant="static-above-dark-uppercase"
          />
          <Slash>/</Slash>
          <CardExpiryYearField
            inputVariant="short"
            labelVariant="static-above-dark-uppercase"
          />
        </CardFrontViewExpiresBlock>
      </CardFrontViewRow>
    </CardFrontView>
    <CardCvcFieldWrapper>
      <CardCvcField
        labelVariant="static-above-dark-uppercase"
        inputVariant="short"
      />
    </CardCvcFieldWrapper>
  </EditCardView>
);

export default EditCard;
